/**
 * Cookie consent utilities — GDPR-compliant consent gate.
 * All marketing (Meta Pixel / CAPI) calls must pass through hasMarketingConsent().
 */

export const CONSENT_KEY = 'cookie_consent';
export const META_PIXEL_ID = '961565099655409';

/** Returns true only when the user explicitly chose "Accept all". */
export function hasMarketingConsent() {
  return localStorage.getItem(CONSENT_KEY) === 'all';
}

/**
 * Read _fbc and _fbp cookies — returns empty strings when marketing consent
 * has not been given or the cookies are absent.
 */
export function getFBCookies() {
  if (!hasMarketingConsent()) return { fbc: '', fbp: '' };
  const map = document.cookie.split(';').reduce((acc, c) => {
    const [k, v] = c.trim().split('=');
    if (k) acc[k.trim()] = v || '';
    return acc;
  }, {});
  return { fbc: map['_fbc'] || '', fbp: map['_fbp'] || '' };
}

/**
 * Fire a Meta Pixel event — no-op if consent not given or fbq unavailable.
 * Always pass the server-generated event_id for deduplication.
 */
export function trackFBQ(eventName, data = {}, opts = {}) {
  if (!hasMarketingConsent()) return;
  if (typeof window.fbq === 'function') {
    window.fbq('track', eventName, data, opts);
  }
}

/**
 * Initialise the Meta Pixel (call only after the user consents).
 * Safe to call multiple times — fbq guards against double-init.
 */
export function initPixel() {
  if (!hasMarketingConsent()) return;
  if (typeof window.fbq !== 'function') return;
  window.fbq('init', META_PIXEL_ID);
  window.fbq('track', 'PageView');
}

/**
 * Immediately expire _fbp and _fbc cookies in the browser.
 * Called when the user changes from 'all' → 'essential'.
 */
export function clearMetaCookies() {
  const gone = 'expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
  document.cookie = `_fbp=; ${gone}`;
  document.cookie = `_fbc=; ${gone}`;
}

/**
 * Dispatch a custom DOM event so any component can trigger
 * "re-open Cookie Settings" without a shared context.
 */
export function openCookieSettings() {
  window.dispatchEvent(new CustomEvent('vw:openCookieSettings'));
}
